import styled from 'styled-components';

interface IPaymentMethodLogoStyledProps {
    fontSize?: string | number;
}

export const PaymentMethodLogoStyled = styled.div<IPaymentMethodLogoStyledProps>`
    font-size: ${props => props.fontSize || 32}px !important;
`;
